import {
  createAction,
} from 'redux-actions'
import {
  apiRequest,
} from '../../helpers/Request'
import * as appActions from './app'
import {
  orderActions,
} from '../types'

export const orderSet = createAction(orderActions.ORDER_SET)
export const orderUpdate = createAction(orderActions.ORDER_UPDATE)


export const fetchPaymentIntent = (token, orderId) => async dispatch => {
  dispatch(appActions.appLoading(true))
  try {
    const { data } = await apiRequest({
      // String concat (not a template literal) to avoid an ESLint 7.21
      // template-curly-spacing crash that aborts the changed-lines lint gate
      // once this file is in the MR's changed set.
      endpoint: '/order/' + orderId + '/payment-intent',
      method: 'post',
      data: { token },
    })
    dispatch(appActions.appLoading(false))
    return data
  } catch (err) {
    dispatch(appActions.appLoading(false))
    const errors = err.response?.data?.error ? [err.response.data.error] : ['Unable to initialize payment. Please try again.']
    dispatch(appActions.appErrors(errors))
    throw err
  }
}

export const submitPayment = data => async dispatch => {
  dispatch(appActions.appLoading(true))
  apiRequest({
    endpoint: '/order/payment',
    method: 'post',
    data,
  }).then(({ status, data: responseData }) => {
    if (status === 200) {
      dispatch(appActions.appLoading(false))
      dispatch(appActions.appSuccesses(['Your payment has been processed.']))
      dispatch(appActions.appStepIncrement())
    } else {
      const { errors } = responseData
      dispatch(appActions.appLoading(false))
      dispatch(appActions.appErrors(errors))
    }
  }).catch((err) => {
    const errors = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : ['Payment could not be processed. Please check that you have entered your payment information correctly']
    dispatch(appActions.appLoading(false))
    dispatch(appActions.appErrors(errors))
  })
}
